module.exports = __webpack_public_path__ + "static/RivieraNights-Ultralight-2d2df372586ca56731ce438ad4958657.woff";